module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"In stock: <b>{qty}</b>":"In stock: <b>{qty}</b>"},"de":{"In stock: <b>{qty}</b>":"Auf Lager: <b>{qty}</b>","Out of stock":"Nicht auf Lager"}}')
  delete Component.options._Ctor
}
